module.exports = __webpack_public_path__ + "img/hotel-18.d2ed9097.jpeg";